export default __webpack_public_path__ + "static/media/resign_black.2542e596.svg";